import * as React from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'

import { tagColor, tagLabel } from 'modules/performance_process/lib/peerAssignmentTag'
import { PerformanceReviewProcessTargetPeerAssignmentStatusEnum } from 'modules/performance_process/lib/peerAssignmentTag'

interface Props {
  status: PerformanceReviewProcessTargetPeerAssignmentStatusEnum
}

export const StatusTag = ({ status }: Props) => {
  return (
    <Box>
      <Tag leftItem="circle" inline capitalize type={tagColor(status)}>
        {tagLabel(status)}
      </Tag>
    </Box>
  )
}
